// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const FeedbackPermissions = zod.object({
  "can_cancel": zod.boolean(),
  "can_comment": zod.boolean(),
  "can_set_status": zod.boolean()
});

export type FeedbackPermissions = zod.input<typeof FeedbackPermissions>;
export type FeedbackPermissionsOutput = zod.output<typeof FeedbackPermissions>;
